import { useMutation, useQueryClient } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const deleteFixedBudgetVesselsQuery = (fixedBudgetVesselIds) => {
  return axios.post(apiurl?.deleteFixedBudgetVessel, { fixedBudgetVesselIds });
};

const deleteFixedBudgetVessels = () => {
  const queryClient = useQueryClient();
  return useMutation(deleteFixedBudgetVesselsQuery, {
    onSuccess: () => {
      queryClient.invalidateQueries('getFixedBudgetVesselList');
    }
  });
};

export default deleteFixedBudgetVessels;
